module.exports = __webpack_public_path__ + "img/Slide18.5ffa34b4.png";